var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    class: _vm.classObj,
    style: ({
      width: _vm.width
    })
  }, [_c('n3-icon', {
    class: (_vm.prefixCls + "-alert-icon"),
    attrs: {
      "type": _vm.iconType
    }
  }), _vm._v(" "), (_vm.dismissable) ? _c('button', {
    class: (_vm.prefixCls + "-close"),
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_c('span', [_vm._v("×")])]) : _vm._e(), _vm._v(" "), (_vm.description) ? _c('div', {
    class: (_vm.prefixCls + "-alert-content")
  }, [_c('h4', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('p', [_vm._t("default")], 2)]) : _c('span', [_vm._t("default")], 2)], 1)])
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4544a12c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4544a12c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Alert/n3Alert.vue
// module id = 618
// module chunks = 0 1